<div class="login-container two-factor-auth">
  <ng-container *ngIf="!tfaDown">
    <ng-container *ngIf="currentScreen === twoFactorAuthScreen['Verify']">
      <h2 class="login-container__title">Enter your verification code</h2>
      <hr class="login-container__divider" />
      <div class="login-container__body">
        <div class="login-container__info-text">
          <p>A text message with a verification code was just sent to {{ displayPhone }}</p>
          <p>Please enter the code to verify your account.</p>
        </div>
        <div class="entry-field entry-field--login">
          <input
            class="entry-field__input"
            id="tfa-sms-code-entry"
            [(ngModel)]="code"
            placeholder="&nbsp;"
            [ngClass]="{ 'tfa-entry-field--error__input': errorMessage }"
            (ngModelChange)="clearErrors()"
          />
          <label class="entry-field__label" for="tfa-sms-code-entry">Enter Code</label>
          <div *ngIf="errorMessage" class="login-container__error">{{ errorMessage }}</div>
        </div>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="submit()"
          [disabled]="!code"
        >
          Verify Account
        </button>
        <p (click)="goToScreen(twoFactorAuthScreen['Trouble'])">
          <span class="login-container__link login-container__link--underlined">Trouble using your code?</span>
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="currentScreen === twoFactorAuthScreen['Trouble']">
      <h2 class="login-container__title">Trouble with your code?</h2>
      <hr class="login-container__divider" />
      <div class="login-container__body">
        <p>We are sorry you're having trouble receiving your code.</p>
        <p>We can resend it via text. Alternatively, we can call you at {{ displayPhone }} to provide a new code.</p>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="sendCode('sms', true); goToScreen(twoFactorAuthScreen['Verify'])"
        >
          RESEND CODE
        </button>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="sendCode('voice', false); goToScreen(twoFactorAuthScreen['Calling'])"
        >
          CALL ME INSTEAD
        </button>
        <p (click)="goToScreen(twoFactorAuthScreen['Contact'])">
          <span class="login-container__link login-container__link--underlined">
            Contact your financial professional
          </span>
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="currentScreen === twoFactorAuthScreen['Calling']">
      <h2 class="login-container__title">We're calling you now</h2>
      <hr class="login-container__divider" />
      <div class="login-container__body">
        <div class="login-container__info-text">
          <p>We are calling {{ displayPhone }} to provide a verification code via audio recording.</p>
          <p>Please enter the code you hear on the phone to verify your account.</p>
        </div>
        <div class="entry-field entry-field--login">
          <input
            class="entry-field__input"
            id="tfa-voice-code-entry"
            [(ngModel)]="code"
            placeholder="&nbsp;"
            [ngClass]="{ 'entry-field--error__input': errorMessage }"
            (ngModelChange)="clearErrors()"
          />
          <label class="entry-field__label" for="tfa-voice-code-entry">Enter Code</label>
          <div *ngIf="errorMessage" class="login-container__error">{{ errorMessage }}</div>
        </div>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="submit()"
          [disabled]="!code"
        >
          Verify Account
        </button>
        <p (click)="goToScreen(twoFactorAuthScreen['Trouble'])">
          <span class="login-container__link login-container__link--underlined">Trouble using your code?</span>
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="currentScreen === twoFactorAuthScreen['Locked']">
      <h2 class="login-container__title">Your code has expired</h2>
      <hr class="login-container__divider" />
      <div class="login-container__body">
        <p>
          To keep your information safe, we only allow three attempts to enter a verification code before it expires.
        </p>
        <p>
          You can try to verify your account again after two hours. Or you can contact your financial professional to
          verify the phone number you are using for verification.
        </p>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="goToScreen(twoFactorAuthScreen['Verify'])"
        >
          TRY AGAIN LATER
        </button>
        <p (click)="goToScreen(twoFactorAuthScreen['Contact'])">
          <span class="login-container__link login-container__link--underlined">
            Contact your financial professional
          </span>
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="currentScreen === twoFactorAuthScreen['Contact']">
      <h2 class="login-container__title">Contact your financial professional</h2>
      <hr class="login-container__divider" />
      <div class="login-container__body">
        <p>
          We're sorry you're having trouble with your verification code. Please contact your financial professional to
          verify the phone number provided.
        </p>
        <div class="login-container__contact-container">
          <p>{{ advisorName }}</p>
          <a class="login-container__info-text--contact" href="tel:+1{{ advisorNumber }}">
            {{ formattedAdvisorNumber }}
          </a>
          <p class="login-container__info-text--contact">{{ advisorEmail }}</p>
        </div>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="exit(false)"
        >
          EXIT
        </button>
        <p (click)="goToScreen(twoFactorAuthScreen['Verify'])">
          <span class="login-container__link login-container__link--underlined">Back to verification options</span>
        </p>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="tfaDown">
    <h2 class="login-container__title">Something Went Wrong</h2>
    <hr class="login-container__divider" />
    <div class="login-container__info-text">
      <p>
        We’re sorry, we encountered a problem while creating your account. We're looking into this and will notify you
        when the issue is resolved.
      </p>
    </div>
    <button class="button button--yellow button--primary login-container__button" role="button" (click)="exit(false)">
      EXIT
    </button>
  </ng-container>
</div>
